<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> v-wechat-title="$route.meta.title"-->
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        v-wechat-title="$route.meta.title"
        :key="$route.fullPath"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      v-wechat-title="$route.meta.title"
    ></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    this.$router.beforeEach((to, from, next) => {
      // console.log('开始打印')
      // console.log(to)
      // console.log(from)
      if (from.name === "提交成功" && to.name === "evaluate") {
        // console.log('从提交成功返回列表页')
        this.$router.go(-2);
        return;
      }
      next();
    });
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #0066ff;
  margin-top: 46px; */
}
.van-nav-bar .van-icon {
  color: rgba(0, 0, 0, 0.9) !important;
}
.van-image-preview {
  background: #ffffff;
}
.van-swipe__track {
  display: flex;
  justify-content: center;
}
.van-swipe-item {
  width: 85% !important;
}
/* 正文文字*/
.weight400-normal-text {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
}
/* 正文文字*/
.weight500-normal-text {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.28rem;
  font-weight: 500;
}
/* 描述文字文字*/
.desc-text {
  color: rgba(0, 0, 0, 0.4);
  font-size: 0.28rem;
  font-weight: 400;
}
/* 正文文字*/
.title-text {
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.36rem;
  font-weight: 500;
}
.van-dialog {
  border-radius: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue